module.exports = __webpack_public_path__ + "img/event_mobile_6_fr.792970da.png";